(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  if (window.FCSMobileHeader) return;
  window.FCSMobileHeader = true;
  var mobile = window.matchMedia('(max-width: 999px)');
  // Keep the native menu/panel controls; only size their scrollport to the visible screen.
  function sizeMobileMenu() {
    if (!mobile.matches || !document.body.classList.contains('fcs-beta-storefront')) return;
    document.querySelectorAll('[data-section-type="header"] .mobile-menu').forEach(function (menu) {
      var header = menu.closest('.header__inner');
      if (!header) return;
      var viewport = window.visualViewport;
      var bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
      menu.style.setProperty('--fcs-menu-height', Math.max(0, bottom - header.getBoundingClientRect().bottom - 12) + 'px');
      var list = menu.querySelector('.mobile-menu__panel:not(.is-nested) .mobile-menu__nav');
      if (list && !list.querySelector('[data-fcs-menu-shortcut]')) {
        [['Find what fits your vehicle', '/pages/vehicle-fit-guide?view=fitguide-beta'], ['Installation help', '/pages/professional-install2']].reverse().forEach(function (entry) {
          var item = document.createElement('li');
          item.className = 'mobile-menu__nav-item';
          var link = document.createElement('a');
          link.className = 'mobile-menu__nav-link fcs-mobile-menu-shortcut';
          link.setAttribute('data-fcs-menu-shortcut', '');
          link.setAttribute('data-type', 'menuitem');
          link.href = entry[1]; link.textContent = entry[0];
          item.appendChild(link); list.prepend(item);
        });
      }
    });
  }
  sizeMobileMenu();
  window.addEventListener('resize', sizeMobileMenu, { passive: true });
  window.addEventListener('scroll', sizeMobileMenu, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', sizeMobileMenu, { passive: true });
    window.visualViewport.addEventListener('scroll', sizeMobileMenu, { passive: true });
  }
  document.addEventListener('shopify:section:load', sizeMobileMenu);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-action="toggle-menu"], [data-fcs-search-toggle]')) window.requestAnimationFrame(sizeMobileMenu);
  });
  function closeSearch(section, returnFocus) {
    var wrapper = section.querySelector('[data-fcs-mobile-search]');
    var button = section.querySelector('[data-fcs-search-toggle]');
    if (!wrapper || !button) return;
    wrapper.removeAttribute('data-fcs-search-open');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Open search');
    if (returnFocus) button.focus();
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-fcs-search-toggle]');
    if (button && mobile.matches) {
      var section = button.closest('[data-section-type="header"]');
      var wrapper = section.querySelector('[data-fcs-mobile-search]');
      if (!wrapper) return;
      var opening = !wrapper.hasAttribute('data-fcs-search-open');
      event.preventDefault();
      if (!opening) { closeSearch(section, true); return; }
      wrapper.setAttribute('data-fcs-search-open', '');
      button.setAttribute('aria-expanded', 'true');
      button.setAttribute('aria-label', 'Close search');
      wrapper.querySelector('[data-fcs-inline-search-input]').focus();
    }
    var close = event.target.closest('[data-fcs-mobile-search] [data-action="unfix-search"]');
    if (close && mobile.matches) closeSearch(close.closest('[data-section-type="header"]'), true);
  });
  // Keep mobile search inline instead of invoking the app's fullscreen autocomplete.
  document.addEventListener('focusin', function (event) {
    if (mobile.matches && event.target.matches('[data-fcs-inline-search-input]')) event.stopPropagation();
  }, true);
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-fcs-desktop-search] #search-product-type');
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var route = option && option.getAttribute('data-fcs-collection-url');
    if (!route) return;
    var destination = new URL(route, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    event.stopImmediatePropagation();
    window.location.assign(destination.pathname + destination.search);
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('[data-fcs-inline-search]')) {
      event.preventDefault(); event.stopImmediatePropagation();
      var input = form.querySelector('[data-fcs-inline-search-input]');
      var query = input.value.trim();
      if (!query) { input.focus(); return; }
      var destination = new URL((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'search', window.location.origin);
      destination.searchParams.set('type', 'product');
      destination.searchParams.set('q', query);
      window.location.assign(destination.pathname + destination.search);
    } else if (form.closest('[data-fcs-desktop-search]')) {
      var search = form.querySelector('[name="q"], input:not([type="hidden"])');
      if (!search || !search.value.trim()) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (search) search.focus();
      }
    }
  }, true);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !mobile.matches) return;
    var section = event.target.closest('[data-section-type="header"]');
    if (section && section.querySelector('[data-fcs-search-open]')) {
      event.preventDefault(); closeSearch(section, true);
    }
  });
  mobile.addEventListener('change', function () {
    document.querySelectorAll('[data-section-type="header"]').forEach(function (section) { closeSearch(section, false); });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
